import { authRepo } from '@porterin/booking-flow/src/auth/domain/repo/authRepo';
import { AuthModalVariant } from '@porterin/booking-flow/src/auth/view/components';
import {
  GaEvents,
  MoeEvents,
} from '@porterin/booking-flow/src/auth/view/stores/AuthAnalyticsStore';
import { makeBkfEventParameterPayload } from '@porterin/booking-flow/src/utils/BookingFlowAnalyticsHelper';
import {
  publishEvent,
  publishEventParameter,
} from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';

type EventStore = { [K in AuthModalVariant]: string };
const getCtaEventName = (auth_state: AuthModalVariant, store: EventStore) => {
  switch (auth_state) {
    case 'login':
      return store.login;
    case 'signup':
      return store.signup;
    case 'otp':
      return store.otp;
    default:
      return '';
  }
};

export const publishAuthCtaTapEvents = (
  category: string,
  event: string,
  auth_state: AuthModalVariant,
  payload?: string,
) => {
  const gaEventName = getCtaEventName(auth_state, GaEvents.ctaTap);
  const gaEventPayload = { [gaEventName]: payload };
  const moeEventName = getCtaEventName(auth_state, MoeEvents.ctaTap);

  publishEvent({
    category,
    action: event,
    label: payload,
  });
  publishEventParameter(gaEventName, gaEventPayload);
  publishEventParameter(moeEventName, makeBkfEventParameterPayload());
};

export const makeSignupEventLabel = (
  name: string,
  email: string,
  whatsapp_consent: boolean,
) => `${name}_${email}_${whatsapp_consent}`;

export const publishNewUserSignupEvent = (mobile: string) => {
  authRepo
    .checkCustomerExists(mobile)
    .then(customer_exist_flag => {
      if (customer_exist_flag.exists === null) {
        publishEventParameter(GaEvents.newUserSignupFail, {
          fe_loginotp_reg_check_failed_parameter: mobile,
        });
      } else if (customer_exist_flag.exists === false) {
        publishEventParameter(GaEvents.newUserSignup, {
          fe_loginotp_registration_parameter: mobile,
        });
      }
    })
    .catch(error => {
      console.log('Error checking customer exists: ', error);
    });
};
